<template>
  <v-app>
    <router-view/>

    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      top
    >
      {{ snackbarText }}
      <v-btn
        text
        @click="snackbar = false"
      >Close</v-btn>
    </v-snackbar>

    <v-footer
      color="primary"
      padless
      app
    >
      <span class="pl-1 caption white--text">&copy; Trouver son cadeau {{ year }}</span>
      <v-spacer></v-spacer>
      <span class="pr-1 caption white--text">{{ builtVersion }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      year: new Date().getFullYear()
    }
  },
  computed: {
    ...mapState('Global', [
      'version',
      'snackbarText',
      'snackbarColor'
    ]),
    builtVersion() {
      const v = []
      switch (process.env.VUE_APP_TARGET) {
        case 'testing':
        case 'production':
          v.push(process.env.VUE_APP_TARGET)
          v.push(`admin v${process.env.VUE_APP_VERSION} (${process.env.VUE_APP_COMMIT})`)
          v.push(`api v${this.version.version} (${this.version.hash})`)
          return v.join(' - ')
        default: return 'Development'
      }
    },
    snackbar: {
      get() { return this.$store.state.Global.snackbar },
      set() { this.$store.commit('Global/setSnackbar', {}) }
    }
  },
  async created() {
    await this.$store.dispatch('Global/getVersion')
  }
}
</script>

<style lang="sass">
[role=link],
[role=button],
.v-data-table tbody tr
  cursor: pointer

.not-clickable,
.v-data-table.not-clickable tbody tr
  cursor: auto
</style>
